var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('button',{on:{"click":_vm.info}},[_vm._v("info")]),_c('h1',[_vm._v("res: "+_vm._s(_vm.res))]),_c('h1',[_vm._v("err: "+_vm._s(_vm.err))]),_c('h3',[_vm._v("logger: "+_vm._s(_vm.logger))])])}
var staticRenderFns = []

export { render, staticRenderFns }